import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

// Scroll reveal wrapper (fade + rise). Gracefully static under reduced-motion.
export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={reduce ? {} : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

// Small indicator that a link opens an external customer service in a new tab.
export const ExternalLinkIcon = ({ className = "" }) => (
  <ArrowUpRight aria-hidden="true" className={`h-4 w-4 ${className}`} />
);

export const SectionLabel = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.16em] text-brand-teal ${className}`}
  >
    <span aria-hidden="true" className="h-px w-8 bg-brand-teal/60" />
    {children}
  </span>
);
